import { render, staticRenderFns } from "./SeatLegend.vue?vue&type=template&id=8bd74926"
import script from "./SeatLegend.vue?vue&type=script&setup=true&lang=js"
export * from "./SeatLegend.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports